package de.oevbs.kunde.kundenportal2

import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.SessionTimerStore
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.appFrame
import de.oevbs.kunde.kundenportal2.navigation.KupoRouter
import dev.fritz2.core.RenderContext
import dev.fritz2.core.Window
import dev.fritz2.core.render
import dev.fritz2.headless.components.toastContainer
import dev.fritz2.headless.foundation.portalRoot
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.mapNotNull

val theRouter = KupoRouter(ROOT_PAGE_ROUTE)

const val contentToastContainer = "content-toast-container"

fun main() {
    render {

        initSessionTimer()
        appFrame()

        /**
         * Container für custom Kundenportal Toasts mit RenderContext-Inhalt.
         * Wird für Popups nach Login genutzt (zB. Anzeige eines Hinweises auf die EWE oder auf ein neues Feature).
         */
        div {
            toastContainer(
                contentToastContainer,
                "absolute top-20 right-5 z-10 flex flex-col gap-0 items-end",
                id = contentToastContainer
            )
        }

        portalRoot()
    }
}

private fun RenderContext.initSessionTimer() {
    // Startet den Session-Timer bei jedem Klick neu, sofern der Nutzer eingeloggt ist. Zusätzlich wird der
    // Timer auch neu gestartet, wenn sich der Login-Status auf "eingeloggt" ändert.
    combine(PortalSession.isLoggedIn, Window.clicks, ::Pair).mapNotNull { (isLoggedIn, _) ->
        Unit.takeIf { isLoggedIn }
    } handledBy SessionTimerStore.restart

    SessionTimerStore.hasExpired.filter { it } handledBy {
        GlobalServiceMessagesStore.addSticky(PortalMessages.sessionTimedOut)
        PortalSession.portalLogout()
    }
}